import MapComponent from './map/index.vue'

if (window.Vue && document.querySelector('#app')) {
  window.Vue.component('map-component', MapComponent)
}
